<template>
  <div>
    <FormItem label="个人姓名：" prop="name">
      <Input v-model="formInvoice.name" readonly disabled></Input>
    </FormItem>
  </div>
</template>

<script>
export default {
  props: ['formInvoice']
};
</script>

<!-- 样式 -->
<style scoped>
/* Add your custom styles here */
</style>
